
import { defineComponent, reactive } from "vue";

export default defineComponent({
    name: "reactive",
    setup() {
        const obj = {
            name: "十三",
            age: 13,
            hobby: ["game", "game"],
            a: {
                b: [0],
            },
        };
        //   把数据变成响应式的数据
        //   返回的是一个Proxy的代理对象，被代理的目标对象就是obj对象
        //   user 现在是代理对象，obj是目标对象
        //   此时user的类型是Proxy
        const user = reactive(obj);
        console.log(user);
        const update = () => {
            //   直接使用目标对象的方式进行更新目标对象，是不可以的，只能使用代理对象的方式进行更新对象(响应式数据)，目标对象也会随之改变
            //   obj.name = "十三--"
            user.name += "==";
            user.age++;
            user.hobby.push("name");
        };
        return {
            obj,
            user,
            update,
        };
    },
});
